if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        document.addEventListener('DOMContentLoaded', () => {
          this.form.querySelector('[name=id]').disabled = false
        })
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      } else {
        console.warn('Form with ID #product-form not found.')
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      // If a frame add-on is selected, include it in the same cart/add request
      const addonFieldset = document.querySelector(
        `.addon-product[data-section-id="${CSS.escape(this.dataset.source)}"]`
      );
      const addonVariantId = addonFieldset && addonFieldset.dataset.selectedAddonVariant
        ? Number(addonFieldset.dataset.selectedAddonVariant)
        : null;
      let cartAddRequest;

      if (addonVariantId) {
        const properties = {};
        let hasProperties = false;
        let hasFileProperty = false;

        // Preserve all line-item properties added by product-option apps.
        // Easify stores uploads and its other selections in properties[...] fields.
        for (const [key, value] of formData.entries()) {
          const propertyMatch = key.match(/^properties\[(.*)\]$/);
          if (!propertyMatch) continue;

          // A real file must remain in the original multipart form request.
          if (value instanceof File) {
            if (!value.size) continue;
            hasFileProperty = true;
            continue;
          }

          properties[propertyMatch[1]] = value;
          hasProperties = true;
        }

        const mainItem = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity') || 1)
        };

        if (hasProperties) mainItem.properties = properties;

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

        if (hasFileProperty) {
          // Shopify's multi-item JSON API cannot carry file uploads. Add the
          // customized product with its untouched multipart FormData first,
          // then add the frame and return the final cart-section response.
          const mainProductConfig = {
            ...config,
            headers: { ...config.headers },
            body: formData
          };
          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          addonConfig.headers['Content-Type'] = 'application/json';

          const addonBody = {
            items: [{ id: addonVariantId, quantity: 1 }]
          };
          if (formData.get('sections')) addonBody.sections = formData.get('sections');
          if (formData.get('sections_url')) addonBody.sections_url = formData.get('sections_url');
          addonConfig.body = JSON.stringify(addonBody);

          cartAddRequest = fetch(`${routes.cart_add_url}`, mainProductConfig)
            .then((response) => response.json())
            .then((mainProductResponse) => {
              if (mainProductResponse.status) return mainProductResponse;
              return fetch(`${routes.cart_add_url}`, addonConfig).then((response) => response.json());
            });
        } else {
          const items = [
            mainItem,
            { id: addonVariantId, quantity: 1 }
          ];
          const jsonBody = { items };
          if (formData.get('sections')) jsonBody.sections = formData.get('sections');
          if (formData.get('sections_url')) jsonBody.sections_url = formData.get('sections_url');
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(jsonBody);
        }
      } else {
        config.body = formData;
      }

      (cartAddRequest || fetch(`${routes.cart_add_url}`, config).then((response) => response.json()))
        .then((response) => {
          if (response.status) {

            // dispatch cart:error
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );

            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // dispatch variant:add when fetch fail
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );

          fetch(`${routes.cart_url}.js`)
            .then((response) => {
              return response.text()
            })
            .then((state) => {
              const parsedState = JSON.parse(state)

              // dispatch cart:change for the entire basket
              document.dispatchEvent(
                new CustomEvent('cart:change', {
                  detail: {
                    cart: parsedState,
                    sectionId: this.dataset.source,
                  },
                })
              )
            })
            .catch((error) => {
              console.error('Error fetching cart state:', error);
            })

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
